import React, { Suspense } from 'react';

import { useSelector, useDispatch } from 'react-redux';

// eslint-disable-next-line no-restricted-imports
import {
  OverlayContext,
  removeOverlay,
} from 'app/gamma/src/modules/state/ui/overlay';
// eslint-disable-next-line no-restricted-imports
import { State } from 'app/gamma/src/modules/types';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ReduxProvider } from 'app/src/components/ReduxProvider';

export const Overlays = () => {
  let component = null;

  const PlanSelectionOverlay = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "plan-selection-overlay" */ 'app/src/components/FreeTrial'
      ),
    {
      preload: false,
      namedImport: 'PlanSelectionOverlayConnected',
    },
  );

  const dispatch = useDispatch();
  const overlay = useSelector((state: State) => state.ui.overlay.overlayType);

  const context: OverlayContext = useSelector(
    (state: State) => state.ui.overlay.context,
  );

  if (overlay === 'plan-selection') {
    component = context?.orgId && (
      <PlanSelectionOverlay
        orgId={context?.orgId}
        startFreeTrialOptions={{ redirect: context?.redirect }}
        // eslint-disable-next-line react/jsx-no-bind
        onClose={() => {
          dispatch(removeOverlay());
        }}
      />
    );
  }

  return <Suspense fallback={null}>{component}</Suspense>;
};

export const WithReduxProvider = () => {
  return (
    <ReduxProvider>
      <Overlays />
    </ReduxProvider>
  );
};
